import React from "react";
import { Link } from "react-router-dom";
import {
  FaBatteryHalf,
  FaCamera,
  FaDatabase,
  FaMicrochip,
  FaMobileAlt,
  FaTint,
} from "react-icons/fa";
import "../pages/Home.css";

const services = [
  { id: 1, name: "Glass Replacement", icon: <FaMobileAlt />, color: "#93c5fd" },
  { id: 2, name: "Logic Board Repair", icon: <FaMicrochip />, color: "#60a5fa" },
  { id: 3, name: "Battery Restoration", icon: <FaBatteryHalf />, color: "#3b82f6" },
  { id: 4, name: "Camera Recovery", icon: <FaCamera />, color: "#2563eb" },
  { id: 5, name: "Water Damage", icon: <FaTint />, color: "#1d4ed8" },
  { id: 6, name: "Data Recovery", icon: <FaDatabase />, color: "#0ea5e9" },
];

const PopularServices = () => {
  return (
    <section className="home-services-section">
      <div className="home-services-container">

        {/* HEADER */}
        <div className="home-services-header">
          <span className="home-services-tag">Our Expertise</span>

          {/* ✅ SEO HEADING */}
          <h2>
            Mobile Repair <span className="home-services-highlight">Services</span>
          </h2>

          {/* ✅ SEO DESCRIPTION */}
          <p>
       We provide mobile repair services in Bangalore including screen replacement,
battery replacement and water damage repair.
          </p>
        </div>

        {/* GRID */}
        <div className="home-services-grid">
          {services.map((service) => (
            <div
              key={service.id}
              className="home-service-card"
              style={{ "--accent": service.color }}
            >
              <div className="home-service-top">
                <div className="home-service-icon-wrapper">
                  <span className="home-service-icon">{service.icon}</span>
                </div>

                {/* ✅ SEO SERVICE NAME */}
                <h3>{service.name} Service</h3>
              </div>

              {/* ✅ CTA SEO */}
              <Link
                to="/services"
                className="home-learn-more"
                style={{ textDecoration: "none" }}
              >
                Get Repair Quote →
              </Link>
            </div>
          ))}
        </div>

        {/* ✅ HIDDEN SEO */}
        <div style={{ display: "none" }}>
          mobile repair services, screen replacement, battery replacement,
          water damage repair, motherboard repair, data recovery mobile repair India
        </div>

      </div>
    </section>
  );
};

export default PopularServices;